import axios from 'axios';
import config from '../../config';

const baseUrl = config.baseUrl;
const endpoint = '/api/sincronizarRitEntregas2';

// Servicio para actualizar datos desde la API externa
export const actualizarDatosTemporalRitEntregas = async () => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}`);
    return response.data; // retorna { ok: true, message: ..., total_registros: ... }
  } catch (error) {
    console.error('Error sincronizando datos temporalRit:', error);
    throw error;
  }
};